import Nav from '../components/layouts/Nav';
import Footer from '../components/layouts/Footer';
import Badge from '../components/common/Badge';
import Button from '../components/common/Button';
import calculator from '../../assets/svg/calculator.svg'
import calculator_brown from '../../assets/svg/calculator-brown.svg'
import Sell from '../components/layouts/Sell';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

function LandingPage(props) {

  const merchant = JSON.parse( window.localStorage.getItem("bMerchant") || "[]") || []

  const history = useHistory()

  // const tranxDetails = window.localStorage.getItem("tranxDetails")

  const [showSell, setShowSell] = useState(props.showSell || false);
  // const [showLogin, setShowLogin] = useState( false );
  const [activeNav, setActiveNav] = useState( "" );
  const [page, setPage] = useState("sell");

  const showSellModal = page => {
    setPage(page)
    setShowSell(!showSell)
  }

  // useEffect( () => {
  //   setShowLogin(true)
  // }, [tranxDetails])

  useEffect(() => {
    setActiveNav(history.location.pathname)
  }, [])

  useEffect( () => {
    if ( props.sell ) {
      showSellModal("sell")
    }
  }, [props.sell])

  return (
    <div className="Landing-page ">
      <Nav className=" text-white">
        <a href="javascript:;" onClick={ () => { setActiveNav("track"); showSellModal("track") } } className={`px-6 ${ activeNav === "track" ? "active-nav" : ""} relative`} >Track Transaction</a>
        <a href="/faq" className={`px-4 ${ activeNav === "/faq" ? "active-nav" : ""} relative`} >FAQ</a>
        <a href="/about" className={`px-4 ${ activeNav === "/about" ? "active-nav" : ""} relative`}>About</a>
        <Badge href="/calculator" className="mx-6 text-brown-dark bg-yellow lg:bg-gray-100 bg-opacity-50 flex items-center justify-center text-xs px-5 py-2 rounded-sm font-bold">
          <img src={showSell ? calculator_brown : calculator} width="14px" alt="c" /> &nbsp;
          Aboki Calculator
        </Badge>
        {/* <div className={`px-6 text-brown ${ showLogin ? "" : "hidden"}`}>Sign In</div> */}
        {/* <a href="https://BitcoinAboki.thebittle.com/auth/login" className="px-6 text-brown">Sign In</a> */}
        <Button 
          className="border border-brown-dark lg:border-yellow text-yellow px-6 cursor-pointer  text-xs px-5 py-3 rounded-sm font-bold" 
          onClick={ () => { showSellModal("sell") } }
        >
          Sell your BTC @ ₦{ merchant.buying_at || "425"}
        </Button>
      </Nav>
      <Sell className={`${showSell ? "open-sell" : "close-sell"}`} onClose={ () => setShowSell(!showSell)} page={page} />    
      <div>
        {
          props.children
        }
      </div>
      <Footer onButtonClick={ () => showSellModal("sell") }></Footer>
    </div>
  );
}

export default LandingPage;
